export default import.meta.ROLLDOWN_FILE_URL_VvRH3c2X8gYoCaXG8sx66A